import { report } from "process";

export const lang = {
  lang: "en",
  welcome: "Welcome",
  quickActions: "Quick Actions",
  country: "USA",
  aamarID: "Aamar ID",
  dashboard: "Dashboard",
  pos: "POS",
  sales: "Sales",
  eCommerceStoreSetup: "E-Commerce Store Setup",
  customers: "Customers",
  accounts: "Accounts",
  accountHead: "Accounts Head",
  transaction: "Transaction",
  products: "Products",
  allProducts: "All Products",
  addProduct: "Add Product",
  update: "Update",
  add: "Add",
  group: "Group",
  generics: "Generics",
  brand: "Brand",
  procurement: "Procurement",
  purchase: "Purchase",
  GRN: "GRN",
  RTV: "RTV",
  TPN: "TPN",
  supplier: "Supplier",
  inventory: "Inventory",
  inventories: "Inventories",
  stockLedger: "Stock Ledger",
  movement: " Movement",
  damage: " Damage",
  exports: "Exports",
  reports: "Reports",
  allReports: "All Reports",
  settings: "Settings",
  backup: "Backup & Restore",
  profileSetting: "Profile Settings",
  users: "Users",
  warehouse: "Warehouse",
  sms: "SMS",
  storeSetting: "Store Settings",
  allAccountsHead: "All Accounts Head",
  updateAccountHead: "Update AccountHead",
  bucketSize: "Bucket Size",
  footFalls: "Foot Falls",
  soldItems: "Sold Items",
  returnItems: "Return Items",
  todaysSales: "Today's Sales",
  paymentsRecieved: "Payments Recieved",
  vat: "Vat",
  duesCollection: "Dues Collection",
  pointSpent: "Point Spent",
  today: "Today",
  last3Days: "Last 3 Days",
  lastWeek: "Last Week",
  last30Days: "Last 30 Days",
  exit: "Exit",
  finalizeSale: "Finalize Sale",
  totalQty: "Total Qty",
  total: "Total",
  vatTaxAmount: "Vat/Tax Amount",
  grossTotal: "Gross Total",
  grossTotalRound: "Gross Total(Round)",
  cashReceived: "Cash Received",
  card: "Card",
  mfs: "MFS",
  discount: "Discount",
  changeAmount: "Change Amount",
  printBill: "Print Bill",
  invoiceNo: "Invoice No",
  bin: "BIN",
  mushak: "Mushak",
  customerPhone: "Customer Phone",
  date: "Date",
  customer: "Customer",
  biller: "Biller",
  outlet: "Outlet",
  orderDetails: "ORDER DETAILS",
  item: "Item",
  qty: "Qty",
  rate: "Rate",
  noProductInPurchaseCart: "No Product in Purchase Cart",
  totalItem: "Total Item",
  dueAdjustment: "Due Adjustment",
  adjust: "Adjust",
  createAdjust: "Create Adjust",
  stockIn: "Stock In",
  createStockIn: "Create Stock In",
  downloadMovementData: "Download Movement Data",
  category: "Category",
  categorySalesReport: "Category Sales Report",
  subcategory: "Sub Category",
  LoyaltyPointSettings: "Loyalty Point Settings",
  netAmount: "Net Amount",
  totalReceived: "Total Received",
  bdt: "BDT",
  productSearch: "Product Search",
  stock: "Stock",
  box: "Box",
  noOfBox: "No of Box",
  price: "Price",
  quantity: "Quantity",
  subTotal: "Sub Total",
  tk: "TK",
  itemNo: "Item No",
  void: "Void",
  hold: "Hold",
  refresh: "Refresh",
  generic: "Generic",
  lastBill: "Last Bill",
  voidReturn: "Void Return",
  scanInvoice: "Scan Invoice",
  returnProduct: "Return Product",
  pleaseScanAnInvoice: "Please Scan An Invoice",
  crateReturn: "Crate Return",
  genericWiseProductSearch: "Generic Wise Product Search",
  searchGeneric: "Search Generic",
  tp: "TP",
  mrp: "MRP",
  allSales: "All Sales",
  profile: "Profile",
  signOut: "Sign Out",
  articleReport: "Article Report",
  categoryReport: "Category Report",
  downloadSalesReport: "Download Sales Report",
  totalMrp: "Total MRP",
  earningDiscount: "Earning Discount",
  returnTotal: "Return Total",
  exportSales: "Export Sales",
  articleSales: "Article Sales",
  categoryWiseArticleSales: "Category Wise Article Sales",
  allCategoriesSales: "All Categories Sales",
  exportSalesCategoryWise: "Export Sales CategoryWise",
  downloadArticleSalesReport: "Download Article Sales Report",
  downloadCategorySalesReport: "Download Category Sales Report",
  downloadCustomerDetails: "Download Customer Details",
  afterSalePayment: "After Sale Payment",
  addExpense: "Add Expense",
  addPayment: "Add Payment",
  dueCollections: "Due Collections",
  collection: "Collection",
  ledgers: "Ledgers",
  allCategories: "All Categories",
  allSubCategories: "All Sub Categories",
  importSubCategories: "Import Sub Categories",
  addSubCategory: "Add Sub Category",
  addCategory: "Add Category",
  addNewCategory: "Add New Category",
  addAccountHead: "Add Account Head",
  importProduct: "Import Product",
  addNewProduct: "Add New Product",
  importGroup: "Import Group",
  importGeneric: "Import Generic",
  importBrand: "Import Brand",
  updateGroup: "Update Group",
  createNewPurchase: "Create New Purchase",
  createNewGrn: "Create New Grn",
  returnToVendor: "Return To Vendor",
  createNewRTV: "Create New RTV",
  createTpn: "Create Tpn",
  goodsReceiveNote: "Goods Receive Note",
  createNewGRN: "Create New GRN",
  report: "Report",
  GRNReport: "GRN Report",
  productOutViaTPN: "Product Out via TPN",
  importSupplier: "Import Supplier",
  importCategories: "Import Categories",
  createSupplier: "Create Supplier",
  inventoryMovement: "Inventory Movement",
  createUser: "create User",
  addSupplier: "Add Supplier",
  updateSupplier: "Update Supplier",
  importCustomer:"Import Customer",
  exportDetails:"Export Details",
  company: "Company",
  name: "Name",
  supplierLedger: "Supplier Ledger",
  productsInventory: "Products Inventory",
  downloadInventoryData: "Download Inventory Data",
  createDamage: "Create Damage",
  downloadReport: "Download Report",
  exportSalesPopularProducts: "Export Sales Popular Products",
  printReport: " Print Report",
  popularProducts: "Popular Products",
  supplierSalesReport: "Supplier Sales Report",
  allCategorySalesReport: "All Category Sales Report",
  sampleImportFiles: "Sample Import Files",
  exportSalesSupplierWise: "Export Sales Supplier Wise",
  loadingCSV: "Loading CSV",
  createCustomer: "Create Customer",
  customerGroup: "Customer Group",
  dueBills: "Due Bills",
  storeSettings: "Store Settings",
  storeLogo: "Store Logo",
  basicInfo: "Basic Info",
  contactInfo: "Contact Info",
  posSettings: "POS Settings",
  vatTaxSettings: "VAT Tax Settings",
  paymentSettings: "Payment Settings",
  smsWrapper: "SMS Wrapper",
  notePlease: "Note Please",
  createWarehouse: "Create Warehouse",
  updateWarehouse: "Update Warehouse",
  allUsers: "All Users",

  createNewUser: "Create New User",
  userDetails: "User Details",
  updateUser: "Update User",
  security: "Security",
};
